/*
 * This cookie is used to display a banner on a PDP page
 * in which the user has successfully registered.
 * The fixed message will also have a confirmation link if the user is not verified.
 * Moving this to the ApplicationWrapper will allow this dangling cookie to be
 * used in a central loation and help with its management. As well as providing
 * the banner throughout the ADC experience.
 *
 */
export const COOKIE_REGISTER_SUCCESS = 'THANK_YOU_REGISTER_BANNER'
